export default __webpack_public_path__ + "static/media/logo.a9010dd6.svg";